import { cropTransparentPadding } from './favicon';
export function processLogoToWhiteOnTransparent(imageUrl) {
  return new Promise((resolve) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      ctx.drawImage(img, 0, 0);

      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      // Iterate pixels: remove near-white background, turn colored pixels to white while preserving alpha
      for (let i = 0; i < data.length; i += 4) {
        const r = data[i];
        const g = data[i + 1];
        const b = data[i + 2];
        const a = data[i + 3];

        if (a === 0) continue;

        // Treat near-white (background) as transparent
        if (r > 240 && g > 240 && b > 240) {
          data[i + 3] = 0;
          continue;
        }

        // Convert the remaining colored pixels (e.g., orange) to white
        data[i] = 255;
        data[i + 1] = 255;
        data[i + 2] = 255;
        // keep alpha
      }

      ctx.putImageData(imageData, 0, 0);

      // Trim transparent padding using the existing favicon util
      const tempImg = new Image();
      tempImg.onload = () => {
        const cropped = cropTransparentPadding(tempImg);
        resolve(cropped);
      };
      tempImg.src = canvas.toDataURL('image/png');
    };
    img.src = imageUrl;
  });
}


